var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-content"},[_c('div',{staticClass:"app-body with-nav"},[_vm._t("default")],2),_c('BottomNav',{attrs:{"current":_vm.currentMenu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }